import { render } from "./AssetGrid.vue?vue&type=template&id=0fb9220d"
import script from "./AssetGrid.vue?vue&type=script&lang=js"
export * from "./AssetGrid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__